import {Plural} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {TeammateModel} from '../../../models/api/teammateModel';
import {TeamModel} from '../../../models/api/teamModel';
import {DropdownItemTeamAvatar} from './dropdownItemTeamAvatar';

/*
 * Style.
 */

const StyledVisibilityDescriptionDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.normal};
`;

/*
 * Props.
 */

interface TeamDropdownItemProps extends DropdownItemProps {
  team: TeamModel;
  shouldRenderVisibilityDescription?: boolean;
  activeTeammatesForTeam: ReadonlyArray<TeammateModel>;
}

/*
 * Component.
 */

export const TeamDropdownItem: FC<TeamDropdownItemProps> = (props) => {
  const {team, isChecked, shouldRenderVisibilityDescription, activeTeammatesForTeam} = props;
  return (
    <DropdownItem {...props}>
      <DropdownItemTeamAvatar team={team} />
      <DropdownItemContent isChecked={isChecked}>
        {team.name}
        {shouldRenderVisibilityDescription && (
          <StyledVisibilityDescriptionDiv>
            <Plural
              id="team-dropdown-item-visibility-description"
              value={activeTeammatesForTeam.length}
              one="# teammate can view"
              other="# teammates can view"
            />
          </StyledVisibilityDescriptionDiv>
        )}
      </DropdownItemContent>
    </DropdownItem>
  );
};
